<template>
  <h1>無料版お申し込みページ</h1>
  <div class="honnbunn">
    <p>{{ serviceTitle }}</p>
  </div>
  <!--申し込み確認内容-->
  <div class="naiyoukakuninn">
    ■お申込内容確認<br />
    <br />
    <span v-for="(item, index) in serviceSettingItems" :key="index">
      <p
        v-if="
          item.displayFlag &&
          item.cmsOnlyFlag === false &&
          item.deleteFlag !== true &&
          item.inputType !== 'agree'
        "
      >
        {{ item.label || item.title }}:
        {{
          index === "companyAddressPostalCode"
            ? "〒" +
              formData[index].slice(0, 3) +
              "-" +
              formData[index].slice(3)
            : getFormattedValue(formData[index], index, item)
        }}
      </p>
      <p
        v-if="
          item.displayFlag &&
          item.cmsOnlyFlag === false &&
          item.deleteFlag !== true &&
          item.inputType === 'agree'
        "
      >
        {{ item.label || item.title }}:
        {{ formData[index] ? "許可" : "" }}
      </p>
    </span>
  </div>
  <br />
  <br />
  <!--[修正する][申し込み]ボタン-->
  <div class="syuuseishitai">
    <ModifyButton @click="modify" />
    <ApplicationButton @click="submitData" />
  </div>
  <loading v-model:active="isLoading" :is-full-page="true" />
</template>
<script>
import { mapState } from "vuex";
import { mapMutations } from "vuex";
import ModifyButton from "@components/atoms/button/modify/modify-button.vue";
import ApplicationButton from "@components/atoms/button/application/application-button.vue";
import Loading from "vue-loading-overlay";
import axios from "axios";

export default {
  name: "confirm-page",
  components: {
    ModifyButton,
    ApplicationButton,
    Loading,
  },
  data() {
    return {
      isLoading: false,
      gaType: "gaEvent",
      gaAction: "gaSoEvent",
      screenName: "confirm",
      startTime: null, // 画面表示開始時刻
      serviceTitle: "",
      serviceSettingItems: {},
      token: "",
    };
  },
  computed: {
    serviceName() {
      return this.formData.serviceName;
    },
    ...mapState({
      formData: (state) => state.formData,
    }),
    ...mapState(["serviceTitle"]),
    ...mapState(["serviceSettingItems"]),
    ...mapState(["token"]),
  },
  mounted() {
    document.title = "お申込内容確認ページ";
    window.scrollTo(0, 0);
    this.startTime = new Date(); // 画面表示開始時刻を記録
    this.sendGaEvent("display", "0");

    // サービス設定情報を反映
    this.serviceTitle = this.$store.state.serviceTitle;
    this.serviceSettingItems = this.$store.state.serviceSettingItems;
    this.token = this.$store.state.token;
  },
  methods: {
    ...mapMutations(["setFormData"]),
    parseJsonField(field) {
      if (typeof field === "string") {
        try {
          const parsedObj = JSON.parse(field);
          return Object.values(parsedObj)[0];
        } catch (e) {
          // JSON解析エラーの場合、そのままの値を返す
          return field;
        }
      }
      // フィールドが文字列でない場合、そのままの値を返す
      return field;
    },
    // GAへのイベント送信処理
    sendGaEvent(action, time) {
      try {
        if (!window.ReactNativeWebView) {
          return;
        }
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            type: this.gaType,
            content: {
              action: this.gaAction,
              args: [
                {
                  service_name: this.serviceName,
                  screen_name: this.screenName,
                  action: action,
                  time: time,
                },
              ],
            },
          }),
        );
      } catch (e) {
        //alert(e); イベント送信がエラーでも申込は続けられるようにする
      }
    },
    async submitData() {
      // フィールド名に "_check_" が含まれているプロパティを削除
      for (const key in this.formData) {
        if (key.includes("_check_")) {
          delete this.formData[key]; // 該当するキーを削除
        }
      }

      try {
        this.isLoading = true;

        // バックエンドに送信
        const response = await axios.post(
          `${process.env.VUE_APP_API_BASE_URL}/soInputCheck`,
          {
            data: this.formData,
            serviceName: this.serviceName,
            type: "regist",
          },
          {
            headers: {
              Authorization: `Bearer ${this.token}`,
            },
          },
        );

        if (response.status === 200 && response.data.status === "success") {
          const endTime = new Date();
          const displayTime = Math.floor(
            (endTime.getTime() - this.startTime.getTime()) / 1000,
          );
          this.sendGaEvent("submit", displayTime.toString());
          this.$router.push("/complete");
          this.$store.state.token = "";
        } else {
          this.$router.push("/error");
        }
      } catch (error) {
        this.$router.push("/error");
      } finally {
        this.isLoading = false;
      }
    },
    modify() {
      const endTime = new Date();
      const displayTime = Math.floor(
        (endTime.getTime() - this.startTime.getTime()) / 1000,
      );
      this.sendGaEvent("return", displayTime.toString());
      this.$router.push(
        "/?serviceName=" + this.serviceName + "&soParam01=&soParam01=",
      );
    },
    getFormattedValue(value, fieldName, item) {
      try {
        // JSON形式の文字列の場合
        const parsed = JSON.parse(value);

        // オブジェクト形式か確認して最初の値を取得
        if (typeof parsed === "object" && parsed !== null) {
          let otherText = ""; // `otherText`を初期化

          // `formData`内に`fieldName + 'OtherText'`が存在するか確認
          if (typeof this.formData[fieldName + "OtherText"] !== "undefined") {
            const fieldSetting = JSON.parse(
              this.serviceSettingItems[fieldName].setting,
            );

            // `other`プロパティが存在するかを確認し、値を取得
            const otherFieldName =
              typeof fieldSetting.other !== "undefined"
                ? fieldSetting.other
                : "";

            // `value`に`otherFieldName`が含まれている場合、`otherText`を設定
            if (value.includes(otherFieldName)) {
              otherText = " (" + this.formData[fieldName + "OtherText"] + ")";
            }
          }

          let retFormattedValue = "";
          for (const value of Object.values(parsed)) {
            retFormattedValue += value + "　";
          }

          // 値に`otherText`を連結して返す
          return retFormattedValue.slice(0, -1) + otherText || "";
        }
      } catch (e) {
        // JSON形式でない場合はパース失敗するためキャッチ
      }

      // 同意項目の表示変換
      if (item.itemType === "agreeItems") {
        return value ? "許可" : "";
      }

      // ファイル情報オブジェクトの場合はファイル名を表示
      if (typeof value === "object" && value !== null && value.name) {
        return value.name;
      }

      // 通常の文字列はそのまま返す
      return value;
    },
  },
};
</script>

<style src="./dx-shukkinbo-confirm.css"></style>
